import { RouterStore } from 'react-router-mobx'

export default new RouterStore()



// WEBPACK FOOTER //
// ./src/stores/router.js